type RawsterBrandProps = {
  className?: string;
  as?: "span" | "h1" | "h2" | "h3" | "div";
  id?: string;
};

export function RawsterBrand({
  className = "",
  as: Tag = "span",
  id,
}: RawsterBrandProps) {
  return (
    <Tag id={id} className={`rawster-brand ${className}`.trim()}>
      Raw<span>ster</span>
    </Tag>
  );
}

type BrandedHeadingProps = {
  children: string;
  className?: string;
  as?: "h1" | "h2" | "h3";
  id?: string;
};

export function BrandedHeading({
  children,
  className = "",
  as: Tag = "h2",
  id,
}: BrandedHeadingProps) {
  const words = children.trim().split(/\s+/);

  if (words.length === 1) {
    return (
      <Tag id={id} className={`rawster-heading ${className}`.trim()}>
        <span className="rawster-heading-accent">{children}</span>
      </Tag>
    );
  }

  const first = words[0];
  const rest = words.slice(1).join(" ");

  return (
    <Tag id={id} className={`rawster-heading ${className}`.trim()}>
      {first} <span className="rawster-heading-accent">{rest}</span>
    </Tag>
  );
}
